import { DEFAULT_PRECISION } from '../../common/constants';
import { round } from '../../common';

export default function ceil(value, step) {
    return round(Math.ceil(value / step) * step, DEFAULT_PRECISION);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/core/utils/ceil.js
// module id = 971
// module chunks = 29